export default __webpack_public_path__ + "static/media/ac_mode_dry.22b71cec.svg";